import services from '@/services.js'
import { modelEmailFactory, modelSmsFactory } from '../templates/models'

export default {
  setCurrentChannel: ({ commit }, infoCard) => {
    commit('UPDATE_CURRENT_CHANNEL', infoCard)
  },

  setMainCampaign: ({ commit }, campaign) => {
    commit('UPDATE_MAIN_CAMPAIGN', { ...campaign })
  },

  setSmsContent: ({ commit }, content) => {
    commit('UPDATE_SMS_CONTENT', content)
  },

  setEmailContent: ({ commit }, content) => {
    commit('UPDATE_EMAIL_CONTENT', content)
  },

  removeChannel: ({ commit }, index) => {
    commit('UPDATE_REMOVE_CHANNEL', index)
  },

  addNewChannel: ({ commit }, channel) => {
    switch (channel) {
      case 'SMS':
        commit('UPDATE_ADD_CHANNEL', modelSmsFactory())
        break
      case 'EMAIL':
        commit('UPDATE_ADD_CHANNEL', modelEmailFactory())
        break
      default:
        throw new Error('No channel')
    }
  },

  saveAudienceTarget: ({ commit }, targetChannel) => {
    commit('UPDATE_AUDIENCE_TARGET', targetChannel)
  },

  saveTime: ({ commit }, targetChannel) => {
    commit('UPDATE_TIME', targetChannel)
  },

  inactiveFlowHandler({ commit }, state) {
    commit('UPDATE_INCATIVE_FLOW', state)
  },

  saveName({ commit }, name) {
    commit('UPDATE_CAMPAIGN_NAME', name)
  },

  saveCampaignId({ commit }, campaignId) {
    commit('UPDATE_CAMPAIGN_ID', campaignId)
  },

  collapse({ commit }, block) {
    commit('UPDATE_COLLAPSE', block)
  },

  setTemplateEmailInChannel({ commit }, payload) {
    commit('UPDATE_EMAIL_TEMPLATE', payload)
  },

  changeStateRocket({ commit }, statusCampaign) {
    commit('UPDATE_ROCKET', statusCampaign)
  },

  savePathCampaign({ state }, obj) {
    return new Promise((resolve, reject) => {
      services
        .patchCampaign(obj.organizationId, obj.campaignId, { campaignWorkflow: state.mainCampaign, lastUpdateDateTime: new Date() })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}
